/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */

import { fromJS } from 'immutable';

import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  SET_SELECTED_POLICY_ID,
  SET_ERROR,
  CLEAR_ERROR,
  FNOL_REPORT_DATE_VALIDATION_STATUS,
  SET_VALIDATE_STEP,
  SET_MEDICAL_AUTHORITY_FORM_LINK,
  SET_MEDICAL_CERTIFICATE_FORM_LINK,
  SET_CLAIM_TYPES,
  SET_VALIDATION_REPORT_DATE_ERROR,
  SET_JSON_VERSION,
  SET_INSURED_LIST,
  SET_CHILD_BENEFITS,
  SET_CLAIM_PAYMENT_VERSION,
  SET_IS_LINKED_COVER,
  SET_INCIDENT_DATE,
  SET_SHOW_ELECTRONIC_CONSENT,
  SET_EMAIL_ADDRESS,
  SET_CLIENT_ID,
  SET_DECLARATION_CLAIMS_ADMIN_COMPANY_NAME,
  SET_TPA_NAME,
  SET_CARRIER_NAME,
  SET_SHOW_REQUIRE_DOCUMENT,
  SET_IS_CLAIM_GROUP_ALLOWED,
  SET_INIT_CLAIM_TYPES_SUCCESS,
  SET_PHONE_NUMBER,
  SET_GUARDIAN_CLIENT_ROLES,
  SET_APPSURE_INSTANCE_SCTI,
} from './constants';

import { configClaimCodeMapper } from '../FastCover/dataMapper/claimCodeMapper';

// The initial state of the App
const initialState = fromJS({
  loading: false,
  error: '',
  isAuthenticated: false,
  selectedPolicyId: 0,
  fnolReportDateValidation: null,
  validateStep: '',
  medicalAuthorityFormLink: '',
  medicalCertificateFormLink: '',
  appClaimTypes: [],
  appChildBenefits: [],
  policyValidationDateErrorMessage: '',
  jsonVersion: '11',
  insuredList: [],
  claimPaymentVersion: '',
  isLinkedCover: false,
  incidentDate: '',
  showElectronicConsentDocument: false,
  emailAddressLogin: '',
  clientId: '',
  FNOLDeclarationClaimsAdminCompanyName: '',
  TPAName: '',
  Carrier: '',
  showRequiredDocument: false,
  isClaimGroupAllowed: false,
  initClaimTypeList: [],
  phoneNumberLogin: '',
  guardianClientRoles: [],
  isAppsureInstanceSCTI: false,
});

function appReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return state.set('isAuthenticated', true);
    case LOGOUT_SUCCESS:
      return state.set('isAuthenticated', false);
    case SET_SELECTED_POLICY_ID:
      return state.set('selectedPolicyId', action.policyId);
    case SET_SHOW_ELECTRONIC_CONSENT:
      return state.set('showElectronicConsentDocument', action.showElectronicConsentDocument);
    case SET_SHOW_REQUIRE_DOCUMENT:
      return state.set('showRequiredDocument', action.showRequiredDocument);
    case SET_IS_CLAIM_GROUP_ALLOWED:
      return state.set('isClaimGroupAllowed', action.isClaimGroupAllowed);
    case SET_APPSURE_INSTANCE_SCTI:
      return state.set('isAppsureInstanceSCTI', action.isAppsureInstanceSCTI);
    case SET_DECLARATION_CLAIMS_ADMIN_COMPANY_NAME:
      return state.set('FNOLDeclarationClaimsAdminCompanyName', action.declarationClaimsAdminCompanyName);
    case SET_TPA_NAME:
      return state.set('TPAName', action.tpaName);
    case SET_CARRIER_NAME:
      return state.set('Carrier', action.carrier);
    case FNOL_REPORT_DATE_VALIDATION_STATUS:
      return state.set('fnolReportDateValidation', action.status);
    case SET_ERROR:
      return state.set('error', action.error);
    case CLEAR_ERROR:
      return state.set('error', '');
    case SET_VALIDATE_STEP:
      return state.set('validateStep', action.step);
    case SET_MEDICAL_AUTHORITY_FORM_LINK:
      return state.set('medicalAuthorityFormLink', action.link);
    case SET_MEDICAL_CERTIFICATE_FORM_LINK:
      return state.set('medicalCertificateFormLink', action.link);
    case SET_CLAIM_TYPES:
      configClaimCodeMapper(action.data, action.policyId);
      return state.set('appClaimTypes', fromJS(action.data));
    case SET_CHILD_BENEFITS:
      configClaimCodeMapper(action.data, action.policyId);
      return state.set('appChildBenefits', fromJS(action.data));
    case SET_VALIDATION_REPORT_DATE_ERROR:
      return state.set('policyValidationDateErrorMessage', action.errorMessage);
    case SET_JSON_VERSION:
      return state.set('jsonVersion', action.version);
    case SET_INSURED_LIST:
      return state.set('insuredList', action.insuredList);
    case SET_GUARDIAN_CLIENT_ROLES:
      return state.set('guardianClientRoles', action.guardianClientRoles);
    case SET_CLAIM_PAYMENT_VERSION:
      return state.set('claimPaymentVersion', action.claimPaymentVersion);
    case SET_IS_LINKED_COVER:
      return state.set('isLinkedCover', action.isLinkedCover);
    case SET_INCIDENT_DATE:
      return state.set('incidentDate', action.incidentDate);
    case SET_EMAIL_ADDRESS:
      return state.set('emailAddressLogin', action.emailAddressLogin);
    case SET_PHONE_NUMBER:
      return state.set('phoneNumberLogin', action.phoneNumberLogin);
    case SET_CLIENT_ID:
      return state.set('clientId', action.clientId);
    case SET_INIT_CLAIM_TYPES_SUCCESS:
      return state.set('initClaimTypeList', action.claimTypeList);
    default:
      return state;
  }
}

export default appReducer;



// WEBPACK FOOTER //
// ./app/containers/App/reducer.js